import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const TableActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: ${Spacing.S4}; /* helper for search border to not be cut by module's overflow */
  margin-bottom: ${Spacing.S12};
`
